<div class="row">
  <div class="col-12">
    <h4 (click)="collapseDeemedDividend843.toggle()"
        [attr.aria-expanded]="!isSectionDeemedDividend843Collapsed"
        aria-controls="deemedDividend843">
      Deemed Dividend 84.3
    </h4>

    <div #collapseDeemedDividend843="ngbCollapse" [(ngbCollapse)]="isSectionDeemedDividend843Collapsed">
      <div class="card table-result-card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'RECU'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Montant reçu
                </div>
              </div>


              <div class="table-result table-result-row table-result-row-indent-1">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'secondary'" [text]="'CAA'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Contrepartie autre qu'en actions
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.section84_3.nonShareConsideration | currencyCents | notAvailable }}</div>
              </div>


              <div class="table-result table-result-row table-result-row-indent-1">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'secondary'" [text]="'AUG CV'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Augmentation du capital versé des actions émises en contrepartie
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.section84_3.totalPaidUpCapital | currencyCents | notAvailable }}</div>
              </div>

              <div class="table-result table-result-row table-result-row-align-indent-0 table-result-row-calculation">
                <div class="table-result-col table-result-col-description text-end">
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'RECU'"></app-output-variable>
                  =
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                                       [text]="'CAA'"></app-output-variable>
                  +
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                                       [text]="'AUG CV'"></app-output-variable>
                  = {{ propertyTransferredResults.section84_3.nonShareConsideration | currencyCents | notAvailable }}
                  + {{ propertyTransferredResults.section84_3.totalPaidUpCapital | currencyCents | notAvailable }}
                  =
                </div>

                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.amountReceived | currencyCents | notAvailable }}</div>
              </div>


              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'CV'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Capital versé des actions transférées
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.section84_3.paidUpCapitalOfTransferredShares | currencyCents | notAvailable }}</div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                                     [style]="'primary'" [text]="'DIV 84'"
                                     class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">
                  Dividende réputé selon 84(3) L.I.R.
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-description text-end">
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'RECU'"></app-output-variable>
                  -
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                       [text]="'CV'"></app-output-variable>
                  =
                  {{ propertyTransferredResults.amountReceived | currencyCents | notAvailable }}
                  -
                  {{ propertyTransferredResults.section84_3.paidUpCapitalOfTransferredShares | currencyCents | notAvailable }}
                  =
                </div>
                <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.deemedDividendFromInternalRollOver | currencyCents | notAvailable }}</div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>